export default {
    endPoints: {}
}